




























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ToggleButton extends Vue {
    @Prop({ required: true }) public collapseId!: string;
    @Prop({ required: true }) public text!: string;
}
